import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { apiService } from '../services/api';
import { toast } from 'react-toastify';
import './ForgotPassword.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [responseMessage, setResponseMessage] = useState('');
  const [isError, setIsError] = useState(false);
  const [devResetLink, setDevResetLink] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      toast.error('Email is required');
      return;
    }

    if (!/^\S+@\S+\.\S+$/.test(email.trim())) {
      toast.error('Please enter a valid email');
      return;
    }

    setLoading(true);
    try {
      const response = await apiService.auth.forgotPassword({ email: email.trim() });
      const data = response.data?.data || {};
      setDevResetLink(data.resetLink || '');
      setResponseMessage(response.data?.message || 'If this email is registered, a reset link has been sent.');
      setIsError(false);
      setSubmitted(true);
      toast.success(response.data?.message || 'If this email is registered, a reset link has been sent.');
    } catch (err) {
      const msg = err?.response?.data?.message || 'Failed to process forgot password request';
      setResponseMessage(msg);
      setIsError(true);
      setSubmitted(true);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password-container">
      <div className="forgot-password-card">
        <div className="forgot-password-header">
          <h1>Forgot Password</h1>
          <p>Enter your email and we will send a password reset link.</p>
        </div>

        {!submitted ? (
          <form onSubmit={handleSubmit} className="forgot-password-form">
            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your registered email"
                autoComplete="email"
              />
            </div>

            <button type="submit" className="forgot-password-button" disabled={loading}>
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>
          </form>
        ) : (
          <div className={isError ? 'forgot-password-error' : 'forgot-password-success'}>
            <p>{responseMessage}</p>
           
          </div>
        )}

        <p className="forgot-password-footer">
          Back to <Link to="/signin">Sign In</Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;
